import client from './client';

export const listPendingManualPayments = (page = 0) =>
  client.get(`/api/credits/payments/pending?page=${page}&size=20`);

export const confirmManualPayment = (id) =>
  client.post(`/api/credits/payments/${encodeURIComponent(id)}/confirm`);
